import {Injectable} from '@angular/core';
import {FormattedNumber} from '@components/ui/table-template/classes/formatted-number';
import {EntityLoanTransactionViewModel} from "../view-models/entity-loan-transaction.view-model";
import {EntityLoanTransactionListDto} from "@dto/holdings/entity-loan-transaction-list.dto";
import {EntityLoanTransactionDto} from "@dto/holdings/entity-loan-transaction.dto";

@Injectable({
  providedIn: 'root'
})
export class EntityLoanTransactionConverterService {

  public convert(transactionList: EntityLoanTransactionListDto): EntityLoanTransactionViewModel[] {
    const transactions = transactionList.entityLoanTransactions;
    const lowestId = Math.min(...transactions.map(transaction => transaction.id));
    return transactions.map(transaction => this.convertSingle(transaction, lowestId));
  }

  private convertSingle(transaction: EntityLoanTransactionDto, lowestId: number): EntityLoanTransactionViewModel {
    const offsetId = transaction.id - lowestId; // Offset the numeric transaction ID by the lowest ID in this set of transactions
    const transactionDate = new Date(transaction.date);
    const offsetDate = new Date(transactionDate.getTime() + offsetId); // Add the transaction's offset ID as milliseconds to differentiate this transaction from others made on the same day

    return {
      date: offsetDate,
      description: transaction.description,
      amount: new FormattedNumber(transaction.amount),
    };
  }
}
